<script lang="ts" setup>
defineProps<{
  errorMessage: string
}>()
</script>

<template>
  <small class="block text-xs font-normal text-error-500 dark:text-error-400">{{
    errorMessage
  }}</small>
</template>
